import { useUnlayerTemplatesEditorContext } from '@/components/views/UnlayerEmailsView/UnlayerTemplatesShared/UnlayerTemplatesEditorView/UnlayerTemplatesEditorContext';
import { OwnerCellData } from '@/components/tables/OwnerCell';
import React from 'react';

const RenderCreatorCell = ({ row }) => {
	const { labels } = useUnlayerTemplatesEditorContext();
	const showAiTemplateFields = Boolean(labels.showAiTemplateFields);
	if (showAiTemplateFields && row?.master) {
		return 'Folio';
	}

	const creatorId = row?.ownerDocId;
	if (creatorId == null) {
		return 'Unknown';
	}

	return <OwnerCellData userId={creatorId} color='text.primary' />;
};
export default RenderCreatorCell;
